module.exports = function() {

  return {
    template: require('html/templates/deliveryCount'),
    restrict: 'E',
    scope: { customer: '=' },
    link: function(scope) {
      scope.deliveryCountTooltipTemplate = require('html/templates/deliveryCountTooltip')();
    }
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/deliveryCount.js
 ** module id = 138
 ** module chunks = 1
 **/